"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChromeStorageEngine = void 0;
const storage_key_constants_1 = require("./storage-key-constants");
/**
 * Chrome storage implementation of a string-valued store for storing a configuration and its metadata.
 *
 * This serializes the entire configuration object into a string and then stores it to a single key
 * within the object for another single top-level key.
 * Same with metadata about the store (e.g., when it was last updated).
 *
 * Note: this behaves a bit differently than local storage as the chrome storage API gets and sets
 * subsets of key-value pairs, so we have to dereference or re-specify the key.
 * @public
 */
class ChromeStorageEngine {
    constructor(storageMap, storageKeySuffix) {
        this.storageMap = storageMap;
        this.getContentsJsonString = async () => {
            const item = await this.storageMap.get(this.contentsKey);
            return item !== null && item !== void 0 ? item : null;
        };
        this.getMetaJsonString = async () => {
            const item = await this.storageMap.get(this.metaKey);
            return item !== null && item !== void 0 ? item : null;
        };
        this.setContentsJsonString = async (configurationJsonString) => {
            await this.storageMap.set(this.contentsKey, configurationJsonString);
        };
        this.setMetaJsonString = async (metaJsonString) => {
            await this.storageMap.set(this.metaKey, metaJsonString);
        };
        const keySuffix = storageKeySuffix ? `-${storageKeySuffix}` : '';
        this.contentsKey = storage_key_constants_1.CONFIGURATION_KEY + keySuffix;
        this.metaKey = storage_key_constants_1.META_KEY + keySuffix;
    }
}
exports.ChromeStorageEngine = ChromeStorageEngine;
//# sourceMappingURL=chrome-storage-engine.js.map